export default "__VITE_ASSET__BXMjCAUd__"